.highlight {
  background: rgba(251, 208, 101, 0.3);
  box-shadow: 0 0 0 2px rgba(251, 208, 101, 0.8);
  border-radius: 5px;
}